export default {"trailingSlash":false}